import React from 'react';

import { Typography } from '@mui/material';



export default function Cost(props) {

    let breed = props.breed

    // if entry "prohibited" exists in breed, then it is prohibited

    if (breed === undefined) {
        return <></>
    }

        return (
            <>
                <Typography variant="h2" gutterBottom>
                    Was kostet ein {breed.breed} aus dem Tierheim?
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    Die Schutzgebühren, die Tierheime erheben, sind von Tierheim zu Tierheim unterschiedlich, unabhängig von der Rasse.
                    Meistens liegt der Preis zwischen <b>200€ und 400€</b>.
                    Die Schutzgebühr beinhaltet tierärztliche Untersuchungen, wie z.B. die Tollwutimpfung und die Registrierung.
                    Eine Kastration erhöht oftmals die Schutzgebühr.
                    Aber auch ein Beitrag für die Versorgung der restlichen Tiere geht in die Schutzgebühr ein.
                </Typography>
            </>
        )
    
    

}
